import { FaRegEdit } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { MdMarkEmailUnread } from "react-icons/md";

// import ActionCenter from "./ActionCenter";
import React, { useContext, useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import AdminExpenseGraph from "../../AdminExpenseGraph";
import UsersAllVouchers from "../../usersAllVouchers";
import Context from "../../../store/Context";

// import UserProfileDetailsEditModal from "./UserProfileDetailsEditModal";
const UserProfileData = () => {
  const ctx = useContext(Context);
  const [detailsEditor, setDetailsEditor] = useState(null);
  const [userDetails, setUserDetails] = useState([]);
  const params = useParams();
  const connectionUrl = process.env.REACT_APP_BACKEND_URL;
  const user = JSON.parse(localStorage.getItem("token"));
  const [currentUserData, setCurrentUserData] = useState({});
  useEffect(() => {
    setUserDetails(ctx.adminCurrentUserData);
  }, [ctx.adminCurrentUserData]);
  useEffect(() => {
    async function fetchDAta() {
      try {
        const response = await axios.post(
          `${connectionUrl}/admin/getUser?id=${params.uid}`,
          {
            token: user.access_token,
            domain: user.domain,
          }
        );
        ctx.AdminCurrentUser(response.data.user);
        // setUserDetails(response.data.user);
      } catch (err) {}
    }
    fetchDAta();
  }, []);
  const deleteUserHandler = async (id) => {
    try {
      const response = await axios.post(`${connectionUrl}/admin/deleteUser`, {
        delId: id,
        token: user.access_token,
        domain: user.domain,
      });

      toast.success("user deleted successfully...");
    } catch (err) {}
  };
  const removePaymentHandlingPermission = async (id) => {
    setUserDetails((prev) => ({ ...prev, paymentAdmin: false }));
    try {
      const response = await axios.post(
        `${connectionUrl}/admin/removePaymentHandlingPermission`,
        {
          paymentAdmin: id,
          token: user.access_token,
          domain: user.domain,
        }
      );

      toast.success("payment handling permission removed ...");
    } catch (err) {
      setUserDetails((prev) => ({ ...prev, paymentAdmin: true }));
      if (err.response && err.response.data.msg) {
        toast.error(err.response.data.msg);
      }
    }
  };
  const givePaymentPermission = async (id) => {
    setUserDetails((prev) => ({ ...prev, paymentAdmin: true }));
    try {
      const response = await axios.post(
        `${connectionUrl}/admin/givePaymentHandlingPermission`,
        {
          paymentAdmin: id,
          token: user.access_token,
          domain: user.domain,
        }
      );

      toast.success("payment handling permission given ...");
    } catch (err) {
      setUserDetails((prev) => ({ ...prev, paymentAdmin: false }));
      if (err.response && err.response.data.msg) {
        toast.error(err.response.data.msg);
      }
    }
  };
  const assignAdminHandler = async (id) => {
    setUserDetails((prev) => ({ ...prev, isAdmin: true }));
    try {
      const response = await axios.post(
        `${connectionUrl}/admin/assignAsAdmin`,
        {
          adminId: id,
          token: user.access_token,
          domain: user.domain,
        }
      );

      toast.success("user assigned as Admin ...");
    } catch (err) {
      setUserDetails((prev) => ({ ...prev, isAdmin: false }));
      if (err.response && err.response.data.msg) {
        toast.error(err.response.data.msg);
      }
    }
  };
  const removeAdminHandler = async (id) => {
    setUserDetails((prev) => ({ ...prev, isAdmin: false }));
    try {
      const response = await axios.post(
        `${connectionUrl}/admin/removeAsAdmin`,
        {
          adminId: id,
          token: user.access_token,
          domain: user.domain,
        }
      );

      toast.success("admin access removed ...");
    } catch (err) {
      setUserDetails((prev) => ({ ...prev, isAdmin: true }));
      if (err.response && err.response.data.msg) {
        toast.error(err.response.data.msg);
      }
    }
  };
  const assignVoucherVerifier = async (id) => {
    setUserDetails((prev) => ({ ...prev, voucherVerifier: true }));
    try {
      const response = await axios.post(
        `${connectionUrl}/admin/giveVoucherVerifyPermission`,
        {
          adminId: id,
          token: user.access_token,
          domain: user.domain,
        }
      );

      toast.success("user assigned as Verifier ...");
    } catch (err) {
      setUserDetails((prev) => ({ ...prev, voucherVerifier: false }));
      if (err.response && err.response.data.msg) {
        toast.error(err.response.data.msg);
      }
    }
  };
  const removeVoucherVerifier = async (id) => {
    setUserDetails((prev) => ({ ...prev, voucherVerifier: false }));
    try {
      const response = await axios.post(
        `${connectionUrl}/admin/removeVoucherVerifyPermission`,
        {
          adminId: id,
          token: user.access_token,
          domain: user.domain,
        }
      );

      toast.success("Voucher Verifier access removed ...");
    } catch (err) {
      setUserDetails((prev) => ({ ...prev, voucherVerifier: true }));
      if (err.response && err.response.data.msg) {
        toast.error(err.response.data.msg);
      }
    }
  };
  return (
    <>
      <div className=" md:w-[calc(100vw-225px)] h-[calc(100vh-70px)] overflow-y-scroll px-4 py-2">
        <div className="text-blue-500 px-2 py-4">
          <p className="text-lg font-bold">User Details</p>
          <p className="text-[.95rem] font-semibold">
            <span>VMS</span> <span className="mx-2"> &gt; </span>
            <span>Users section</span>
            <span className="mx-2"> &gt; </span>
            <span>User Details</span>
          </p>
        </div>
        <div className="md:w-[100%] py-4 px-4 ">
          <div className=" ">
            <div>
              <div className="bg-[#2E3648] relative shadow p-2 rounded-lg text-gray-800 hover:shadow-lg">
                <div className="right-0 mt-4 rounded-l-full absolute text-center font-bold text-xs text-white px-2 py-1 bg-orange-500">
                  {userDetails?.supervisor && !userDetails?.isAdmin && (
                    <p className=" text-[.75rem] lg:text-[.9rem] font-semibold  px-2 rounded-md flex items-center mx-1">
                      SuperVisor{" "}
                    </p>
                  )}{" "}
                  {userDetails?.isAdmin && (
                    <p className=" text-[.75rem] lg:text-[.9rem] font-semibold  px-2 rounded-md flex items-center mx-1">
                      Admin{" "}
                    </p>
                  )}
                  {!userDetails?.supervisor && !userDetails?.isAdmin && (
                    <p className=" text-[.75rem] lg:text-[.9rem] font-semibold  px-2 rounded-md flex items-center mx-1">
                      User
                    </p>
                  )}
                  {userDetails?.paymentAdmin && (
                    <p className=" text-[.75rem] lg:text-[.9rem] font-semibold  px-2 rounded-md flex items-center mx-1">
                      Payment Handler
                    </p>
                  )}
                  {userDetails?.voucherVerifier && (
                    <p className=" text-[.75rem] lg:text-[.9rem] font-semibold  px-2 rounded-md flex items-center mx-1">
                      Voucher Verifier
                    </p>
                  )}
                </div>
                <img
                  src="https://images.unsplash.com/photo-1564497717650-489eb99e8d09?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1963&q=80"
                  className="h-32 rounded-lg w-full object-cover"
                />
                <div className="flex justify-center">
                  <img
                    src={userDetails?.profilePic}
                    // src="https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
                    className="rounded-full -mt-12 border-4 object-center object-cover border-white mr-2 h-24 w-1624"
                  />
                </div>
                <div className="py-2 px-2 text-white">
                  <div className=" font-bold font-title  items-center flex flex-col">
                    <p className="text-wrap   mx-2 ">
                      {(userDetails?.firstName || "") +
                        " " +
                        (userDetails?.lastName || "")}
                    </p>
                    <p className="text-sm font-normal">
                      {userDetails.designation ? "software developer" : ""}
                    </p>
                  </div>
                  <div className="flex font-semibold justify-center  max-sm:flex-col">
                    {" "}
                    <div className="text-sm flex  sm:text-center items-center my-2 px-2 sm:border-e-2">
                      <MdMarkEmailUnread className="w-[20px] h-[20px] text-blue-400 " />{" "}
                      <p className="text-wrap  mx-2 flex flex-wrap">
                        {userDetails?.email || "no email provided"}
                      </p>
                    </div>
                    <div className="text-sm flex text-center items-center  my-2 px-2">
                      <IoCall className="w-[20px] h-[20px] text-blue-400" />{" "}
                      <p className="text-wrap mw-[100%]  mx-2">
                        {userDetails?.mobile != null ? (
                          userDetails?.mobile
                        ) : (
                          <p className="bg-blue-500 px-2 rounded-md text-[.8rem]">
                            not provided
                          </p>
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="flex justify-center items-center  text-sm  font-semibold ">
                    <div className="flex my-2 flex-wrap gap-2">
                      {userDetails?.isAdmin ? (
                        <p
                          className="border-2 bg-red-600 px-2 flex flex-nowrap rounded-md text-[.75rem] lg:text-[.9rem] font-bold text-white cursor-pointer hover:bg-red-700 w-fit  whitespace-nowrap"
                          onClick={() => {
                            removeAdminHandler(userDetails.id);
                          }}
                        >
                          Remove Admin
                        </p>
                      ) : (
                        <p
                          className="border-2 bg-green-600 px-2  flex flex-nowrap rounded-md text-[.75rem] lg:text-[.9rem] font-bold text-white cursor-pointer hover:bg-green-700  w-fit  whitespace-nowrap"
                          onClick={() => {
                            assignAdminHandler(userDetails.id);
                          }}
                        >
                          Assign Admin
                        </p>
                      )}
                      {!userDetails?.voucherVerifier ? (
                        <p
                          className="border-2 bg-green-600 px-2  flex flex-wrap rounded-md text-[.75rem] lg:text-[.9rem] font-bold text-white cursor-pointer hover:bg-green-700  w-fit  whitespace-nowrap"
                          onClick={() => {
                            assignVoucherVerifier(userDetails.id);
                          }}
                        >
                          Assign Voucher Verifier
                        </p>
                      ) : (
                        <p
                          className="border-2 bg-red-600 px-2 flex flex-nowrap rounded-md text-[.75rem] lg:text-[.9rem] font-bold text-white cursor-pointer hover:bg-red-700 w-fit  whitespace-nowrap"
                          onClick={() => {
                            removeVoucherVerifier(userDetails.id);
                          }}
                        >
                          Remove Voucher Verifier
                        </p>
                      )}
                      {!userDetails?.paymentAdmin ? (
                        <p
                          className="border-2 bg-green-600 px-2  flex flex-wrap rounded-md text-[.75rem] lg:text-[.9rem] font-bold text-white cursor-pointer hover:bg-green-700  w-fit  whitespace-nowrap"
                          onClick={() => {
                            givePaymentPermission(userDetails.id);
                          }}
                        >
                          Assign Payment Approver
                        </p>
                      ) : (
                        <p
                          className="border-2 bg-red-600 px-2 flex flex-nowrap rounded-md text-[.75rem] lg:text-[.9rem] font-bold text-white cursor-pointer hover:bg-red-700 w-fit  whitespace-nowrap"
                          onClick={() => {
                            removePaymentHandlingPermission(userDetails.id);
                          }}
                        >
                          Remove Payment Approver
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="   lg:columns-2 px-4 rounded-sm">
          <div className="bg-[#2E3648] w-[100%] h-[65vh] overflow-y-auto rounded-md ">
            <div className="text-center bg-white h-[100%]">
              <AdminExpenseGraph></AdminExpenseGraph>
            </div>
          </div>{" "}
          <div className="shadow-md  w-[100%]   h-[65vh]   my-2 rounded-lg">
            <UsersAllVouchers></UsersAllVouchers>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserProfileData;
